// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3gbiB","buttons":"SendReceipts_buttons__39kto","email":"SendReceipts_email__1NUmI","bookApptTitle":"SendReceipts_bookApptTitle__3787o"};